import { Fragment, useState, useCallback } from 'react';
import { useCookies } from "react-cookie";
import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';
import { Input } from '../../FormControls/Input';
import { Button } from '../../FormControls/Button';
import { AlertBox } from "../../FormControls/alert";
import { jump } from "../../../../main/slices/routerSlice";
import { useDispatch, useSelector } from 'react-redux'
import { createOtp, valOtp } from '../../../../main/slices/storeSlice';
import { setEmail, checkForUser, sendEmailUser, registerUser, handleMinikitUser, setIdUser, getMiniappUser } from '../../../../main/slices/userSlice';
import { ScreenControl } from '../ScreenControl';
import { useEffect } from 'react';
import { Report, ContentPaste, Sync, ArrowBack } from '@mui/icons-material';
import { COLORS } from '../../../styles/defaults';
import { SafeArea } from '../../FormControls/SafeArea';

const EmailComponent = ({ email, emailChange }) => {

    return (
        <Fragment>
            <Box>
                <Text classes={["title", "left", "center"]}> Te enviaremos un código de verificación </Text>
                <div style={{ marginBottom: "3rem" }}></div>
                <Text classes={["description"]}> Ingresa tu correo electrónico </Text>
                <div style={{ marginBottom: "0.75rem" }}></div>
                <Stack
                    flex={{
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >

                    {/* SCREEN LEGENDS */}
                    {//INVALIR EMAIL ALERT
                        (email.error && email.value) &&
                        <Text classes={["description", "alignContent", "error"]} style={{ "justifyContent": "flex-start", "margin": "0.5em 0" }}>
                            <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                            Correo electrónico no válido
                        </Text>
                    }

                    {/* EMAIL INPUT */}
                    <Input
                        type="email"
                        classes={[email.error && email.value ? "error" : ""]}
                        placeHolder="Correo electrónico"
                        attributes={{ value: email.value }}
                        onChange={emailChange}
                    />

                </Stack>
            </Box>
            <div style={{ marginBottom: "1rem" }}></div>
        </Fragment>
    );
}

const CodeComponent = ({ email, handleDigitsChange, handleKeyDown, digit, setDigit, setTimerActive, setCookiesTime }) => {
    // EQUIVALENT TO 3 MINUTES
    const EXPIRATION_TIME = 180000;
    const [cook, setCookies] = useCookies(["otpTime"]);
    const [cookies] = useCookies(["otpTime"]);
    const [procedure] = useCookies(["procedure"]);
    const [count, setCount] = useState({ sec: "--", min: "-" });

    // REMAINING TIME IN MILISECONDS
    const [time, setTime] = useState(Number(cookies["otpTime"]) || EXPIRATION_TIME);
    const dispatch = useDispatch();

    // PASTE CODE
    const handlePaste = async () => {
        try {
            // READ CLIPBOARD
            const copyCode = await navigator.clipboard.readText();
            const otpArray = copyCode.split('').slice(0, 6);
            setDigit(otpArray)
            // ADD TEXT INTO OTP'S INPUTS
            for (let i = 0; i < otpArray.length; i++) {
                const nextField = document.getElementById(`otp${i}`);
                nextField.value = otpArray[i];
            } 
        } catch (err) {
          console.error('invalid action');
        }
      };

    const calculateTime = useCallback(() => {
        // CALCULATE THE REMAINING TIME (IN MINUTES)
        const remaining = (EXPIRATION_TIME - ((new Date()).getTime() - time)) / 60000;

        // IF THERE IS STILL TIME
        if (remaining > 0) {
            if(remaining<0.02){//DISABLE BUTTON ACEPT
                setTimerActive(false);
            }
            // SET THE MINUTES AND SECONDS
            const [min, sec] = String(remaining).split('.');
            setCount({
                sec: Math.round(Number("0." + sec) * 60),
                min: min
            });
        }
    }, [time]);

    // START TIMER
    useEffect(() => {
        const timer = setInterval(() => calculateTime(), 1000);
        return () => clearInterval(timer);
    }, [calculateTime]);

    // RESET TIME
    const restartTimer = () => {
        setTimerActive(true)
        // Reiniciar el tiempo a EXPIRATION_TIME
        const now = new Date().getTime();
        setTime(now);
        setCookiesTime("otpTime", now, { path: "/" }); 
        setCount({ sec: 0, min: 3 });
    };

    // ACTIONS WHEN PRESS NUMBER
    const handleChange = useCallback((i) => (e) => {
        const value = e.target.value;
        if (/^\d$/.test(value) || value === '') {
            handleDigitsChange(i, value);
        }
    }, [handleDigitsChange]);

    const handleUp = useCallback((i) => (e) => {
        handleDigitsChange(i, e.target.value);
    }, [handleDigitsChange]);

    const handleDown = useCallback((i) => (e) => {
        handleKeyDown(i, e);
    }, [handleKeyDown]);


    return (
        <>
            <Fragment>
                <Box>
                    <Text classes={["title", "center"]}>Código de verificación enviado a: <span style={{ fontWeight: "bold" }}>{email}</span> </Text>
                    <div style={{ marginBottom: "3rem" }}></div>
                    <Text classes={["description"]}> Ingresa el código: </Text>
                    <div style={{ marginBottom: "1rem" }}></div>
                    <Stack 
                        style={{ paddingLeft: "0.80rem"}}
                        flex={{ justifyContent: "space-between" }}>
                        {[0, 1, 2, 3, 4, 5].map((i) =>
                            <Input
                                key={i} 
                                style={{ width: "2.35rem" }}
                                type="text"
                                value={digit[i]}
                                classes={["width15", "textCenter"]}
                                maxLength={1}
                                attributes={{ 
                                    inputMode: "numeric",
                                    // pattern: "[0-9]{1}",
                                    maxLength: 1, 
                                    id: `otp${i}`,
                                    onKeyUp: handleUp(i),
                                    onKeyDown: handleDown(i),
                                }}
                                placeHolder="-" 
                                onChange={handleChange(i)}
                            />
                        )}
                    </Stack>
                
                    { ((count.min == 0 && count.sec <= 1) || (count.min=="-" && count.sec=="--")) ? (
                        <Box style={{ marginTop: "1em" }}>
                            <Stack flex={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{"color": COLORS.primary.acept, "background": COLORS.primary.acept}}
                                    onClick={() => {
                                        let typeOtp = cookies["procedure"]=="register" ? "auth" : "login"
                                        dispatch(createOtp({
                                            "origin":"worldpos",
                                            "email": email,
                                            "type": `${typeOtp}`
                                        }))
                                        // dispatch(sendEmailUser())
                                        restartTimer();
                                    }}
                                >
                                    <Stack flex={{ flexDirection: "row", gap: 5 }}>
                                        <Sync style={{"color": "white"}} fontSize="inherit" />
                                        <Text 
                                            style={{"color": "white"}}
                                            classes={["description", "center"]} 
                                        >
                                            Re enviar código
                                        </Text>
                                    </Stack>
                                </Button>
                            </Stack>
                        </Box>    
                        ) : (
                        <Box style={{ marginTop: "1em" }}>
                            <Stack flex={{ flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                {/* <Text>hola</Text> */}
                                <Button
                                    style={{"color": COLORS.primary.font, "background": COLORS.primary.font}}
                                    onClick={() => {handlePaste()}}
                                >
                                    <Stack flex={{ flexDirection: "row", gap: 5 }}>
                                        <ContentPaste  style={{"color": COLORS.primary.main}} fontSize="inherit" />
                                        <Text 
                                            style={{"color": COLORS.primary.main}}
                                            classes={["description", "center"]} 
                                        >
                                            Pegar código
                                        </Text>
                                    </Stack>
                                </Button>
                            </Stack>
                            <Text 
                                classes={["description", "center"]} 
                                style={{ 
                                    "align":"center", 
                                    "justifyContent": "flex-start", 
                                    "margin": "0.5em 0",
                                    // "color": COLORS.primary.main, "background": COLORS.primary.fondoItem
                                }}>
                                Reenviar código en:
                            </Text>
                            <Stack flex={{ alignItems: "baseline", justifyContent: "center" }}>
                                <Text classes={["bigTitle", "autoWidth"]}> {count.min} </Text>
                                <Text classes={["description", "autoWidth"]}> min </Text>
                                <div style={{ margin: "0 0.5em" }}></div>
                                <Text classes={["bigTitle", "autoWidth"]}> {count.sec} </Text>
                                <Text classes={["description", "autoWidth"]}> seg </Text>
                            </Stack>
                        </Box>)
                    }
                </Box>
                <div style={{ marginBottom: "2rem" }}></div>
            </Fragment> 
        </> 
    );
}

const Main = ({ dimensions, path, state }) => {
    // COMPONENT STATES
    let [digits, setDigits] = useState(Array(6).fill(""));
    const [timerActive, setTimerActive] = useState(true);
    const [cookies, setCookies] = useCookies(["otpTime"]);
    const [statusPath, setPath] = useState("email");
    const dispatch = useDispatch();
    // ALERT
    const [showAlert, setShowAlert] = useState(false); // view alert
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [alertTitle, setAlertTitle] = useState(null);

    const handleEmailChange = (key, value) => {
        if (key === "email"){ 
            dispatch(setEmail({ value, error: !value }));
        }
    }

    // CLOSE ALERT MESSAGE
    const handleCloseAlert = () => setShowAlert(false);

    // WRITE OTP 
    const handleDigitsChange = (i, val) => {
        if (/[^0-9]/.test(val)) return;
        let newOtp = [...digits];
        newOtp[i] = val;
        setDigits(newOtp);

        // GO TO THE NEXT INPUT
        if (val !== "" && i < 5) {
            const nextField = document.getElementById(`otp${i + 1}`);
            nextField?.focus();
        }
    }

    // CLEAR OTP
    const handleKeyDown = (i, e) => {
        // IF PRESS "BACKSPACE", GO BACK INPUT
        if (e.key === "Backspace" && digits[i] === "") {
            if (i > 0) {
                const prevField = document.getElementById(`otp${i - 1}`);
                prevField?.focus();
            }
        }
    };

    const updateUserInfo = async (data) =>{
       try {
            const { response } = await dispatch(handleMinikitUser(data)).unwrap();
            return true;
        } catch (error) {
            console.error("Error actualizando usuario:", error);
            return false;
        }
    }
    
    // CALL ENDPOINTS MINIAPP
    const check = async () => {
        //VARS TO VERIFICATE USER
        let userExist = false
        let userId = false
        let payload = {}
        let procedure= cookies["procedure"]
        let sendOtp = false;
        
        if (!state.email.error){ await dispatch(checkForUser())
            .unwrap()
            .then(async ({response}) => {
                setCookies("otpTime", (new Date()).getTime());
                if(response.statusCode == 200) {
                    userExist = true
                }
            })
            .catch(e => {false});
        }
        // USER IS'T EXIST
        if(!userExist == true){
            // REGISTER
            if(procedure=="register"){//--> Si esta registrando un nuevo comercio
                await dispatch(registerUser())
                .unwrap()
                .then(async ({response}) => {
                    if(response.status == 200) {
                        payload["id"] = response.user.user.uid;
                        payload["email"] = state.email.value;
                        payload["idWLD"] = `${state.idWLD}`
                        payload["origin"] = `worldpos`;
                        let Data = { payload, action: "update_recibe", userId: state.idWLD};
                        
                        let updateUser = await updateUserInfo(Data);

                        if(updateUser==false){
                            setAlertTitle("Error")
                            setAlertType('error');
                            setAlertMessage(`Error al intentar guardar el usuario.`);
                            setShowAlert(true);
                            return false
                        }
                        userId = true

                    }else{
                        setAlertTitle("Error")
                        setAlertType('error');
                        setAlertMessage(`Error al crear al usuario.`);
                        setShowAlert(true); 
                        return false   
                    }
                })
                .catch(e => {
                    setAlertTitle("Error")
                    setAlertType('error');
                    setAlertMessage(`Error inesperado.`);
                    setShowAlert(true);
                    return false
                });
            }else if(procedure=="login"){ //--> Si intenta hacer login
                setAlertTitle("Error")
                setAlertType('error');
                setAlertMessage(`Usuario invalido.`);
                setShowAlert(true);

                return false
            }    
        }else{
            // GET UID
            const { response } = await dispatch(getMiniappUser({email: state.email.value})).unwrap();
            if(response != undefined || response != ""){
                payload["id"] = response;
                payload["email"] = `${state.email.value}`;
                payload["origin"] = `worldpos`;
                payload["idWLD"] = `${state.idWLD}`
                
                // UPDATE USER DATA INTO EXTERNAL USERS
                let Data = { payload, action: "update_recibe", userId: state.idWLD};
                let updateUser = await updateUserInfo(Data);
                if(updateUser==false){
                    setAlertTitle("Error")
                    setAlertType('error');
                    setAlertMessage(`Error al intentar actualizar el usuario.`);
                    setShowAlert(true);
                    return false
                }
                userId = true
            }
        }

        if(userId == true){
            let typeOtp = procedure=="register" ? "auth" : "login";
            let cont = 0;

            //INTENTOS PARA ENVIAR EL OTP (POR USUARIOS RECIEN REGISTRADO)
            while (sendOtp==false && cont!=3){
                await dispatch(createOtp({
                    "origin":"worldpos",
                    "email": state.email.value,
                    "type": `${typeOtp}`
                }))
                .unwrap()
                .then(async ({response}) => {
                    if(response.code == 200){
                        // UPDATE USER DATA
                        if(procedure == "register"){
                            dispatch(setIdUser(payload["id"]));
                        }
                        sendOtp=true;
                        // return true;
                    }else {
                        // if(procedure == "register"){
                        //     setAlertTitle("Error")
                        //     setAlertType('error');
                        //     setAlertMessage(`No se completo la generación de OTP.`);
                        //     setShowAlert(true);
                        // }
                        
                        // return false;
                    }  
                })

                cont= cont + 1;
            }

            if(sendOtp==false){
                setAlertTitle("Error")
                setAlertType('error');
                setAlertMessage(`No se completo la generación de OTP.`);
                setShowAlert(true);
            }

            return sendOtp;
        }

        return false; 
    }

    function goPage(){
        let page = 3;
        if(cookies["procedure"]== "login" ){
            page= 14;
        }

        return page;
    }

    // GENERATES THE CONTRACT AND ONESHOT REQUETS
    const verifyOtp = async () => {
        let payload = {}
        // let token = cookies["procedure"]=="register" ? `${state.id}` : `${state.id}`
        if (digits.length > 0){
            return await dispatch(valOtp({
                email: `${state.email.value}`, 
                origin: "worldpos",
                numberOtp: digits.reduce((a, b) => a + b)
            })).unwrap()
            .then(async ({ response }) => {
                if (response.error === false && response.code=== 200) {
                    payload["email"] = `${state.email.value}`
                    payload["idWLD"] = `${state.idWLD}`

                    let Data = { payload , action: "update_recibe", userId: state.idWLD};
                    let updateUser = await updateUserInfo(Data);
                    if(updateUser==false){
                        setAlertTitle("Error")
                        setAlertType('error');
                        setAlertMessage(`Error al intentar guardar el usuario.`);
                        setShowAlert(true);
                        return false
                    }
                    dispatch(handleMinikitUser(Data));
                    dispatch(jump({ current: -1, direction: "backward", }));
                    return true
                }else{
                    setAlertTitle("Error")
                    setAlertType('error');
                    setAlertMessage(`Código invalido.`);
                    setShowAlert(true);
                    return false
                };
            })
            .catch(e => {
                setAlertTitle("Error")
                setAlertType('error');
                setAlertMessage(`Error inseperado.`);
                setShowAlert(true);
                return false
            });
        }
        return false
    }

    function isFull(array) {
        return array.every(item => item.trim() !== ""); // Verifica que ningún elemento sea una cadena vacía
    }

    const route = (path, timerActive) => {
        const regex = /^[0-9]+$/
        // FOR THE PATH "email"
        if (path === "email") return {
            index: { fw: -1 },  // IF fw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE FORWARD BUTTON
            path: "otp",        // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: state.email.error,
            beforeSubmit: () => check()
        }
        // FOR THE PATH "otp"
        else if (path === "otp") return {
            index: { bw: -1, fw: goPage() },  // IF bw = -1, STAYS IN THE CURRENT SCREEN TRIGGER BY THE BACKWARD BUTTON
            path: "email",      // THE NEXT PATH THE COMPONENT IS GOING TO RENDER
            disabled: !isFull(digits) || !timerActive,
            beforeSubmit: async () => {
                const returnVal = await verifyOtp()
                if(returnVal==false){
                    setAlertTitle("Error")
                    setAlertType('error');
                    setAlertMessage(`Código invalido.`);
                    setShowAlert(true);
                    for (let i = 0; i < 6; i++) {
                        const nextField = document.getElementById(`otp${i}`);
                        digits[i]="";
                        nextField.value = "";
                    } 
                }else{
                    return true;
                }
            }
        }
    }

    return (
        <Fragment>
            <SafeArea style={{ flex: 1 }}>
                <div style={{ padding: "0 1.5rem" }}>
                    {/* ALERT */}
                    {showAlert && (
                        <AlertBox
                        message={`${alertMessage}`}
                        type={alertType}
                        title={alertTitle}
                        onClose={handleCloseAlert}
                        />
                    )}

                    {/* PHONE NUMBER COMPONENT */}
                    {path === "email" && <EmailComponent
                        email={state.email}
                        emailChange={({ target }) => handleEmailChange("email",target.value)}
                    />}

                    {/* OTP VERIFICATION COMPONENT */}
                    {path === "otp" && <CodeComponent
                        cookies={cookies}
                        email={state.email.value}
                        handleDigitsChange={handleDigitsChange}
                        handleKeyDown={handleKeyDown}
                        digit={digits}
                        setDigit={setDigits}
                        setCookiesTime= {setCookies}
                        setTimerActive = {setTimerActive}
                        number={'123'}
                    />
                    }
                </div>
                {/* CONTROLLER */}
                <ScreenControl
                    btncolor={"cobrarBtn"}
                    btnText={"Continuar"}
                    {...route(path, timerActive)}
                />
                <div style={{ marginBottom: "10rem" }}></div>
                
            </SafeArea>
        </Fragment>
    );
}

export const SendOTP  = ({ dimensions, path }) => {
    const state = useSelector(({ user }) => user);
    return <Main dimensions={dimensions} path={path} state={state} />;
}
